module.exports = __webpack_public_path__ + "img/video.9bd31b4c.png";